import { useEffect } from "react"
import { ThemeMode } from "../../modules/theme/types"

export const useThemeHandler = (mode: ThemeMode) => {
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", mode)
  }, [mode])
}
